import React from "react";
import {FormattedMessage} from "react-intl";


function TakeAwayOrderReviewActionsBar(props) {
    return (
        <div className={props.isVisible ? "actionsbar show" : "actionsbar"}>
            <div className="row buttons-row">
                <button className={props.btnClassName} data-qa={props.dataQAIdentifier} onClick={props.buttonAction}>
                    {props.buttonName}
                </button>
            </div>

            <div className="row text-row">
                <p className="total-products">{props.totalProducts}  {props.totalProducts !==1 ?  <FormattedMessage id="Products"/> : <FormattedMessage id="Product"/>   }  </p>
                <p className="total-price">{props.totalPrice}</p>

            </div>

        </div>
    );
}

export default TakeAwayOrderReviewActionsBar;
